export default __webpack_public_path__ + "static/background-1-dcda743970ab71641e4859b7a280436e.svg";